import {createAction} from 'redux-actions';
import {ARTICLES_SET_ACTIVE_FILTERS, ARTICLES_SORT} from '../../action-types';

export const setActiveFilters = createAction(ARTICLES_SET_ACTIVE_FILTERS, (activeFilters, data) => v12.filter.set(activeFilters, data));

export const sort = sort => dispatch => dispatch({
	type: ARTICLES_SORT,
	sort
});
